import { Badge } from "@mantine/core";
import { useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useEffect } from "react";
import SimpleBar from "simplebar-react";
import DualListBox from "react-dual-listbox";

const AssignationPPEPosition = ({ key, position, itemsList, validation, selectedOptionsList, setSelectedOptionsList }) => {
    const [optionsList, setOptionsList] = useState([]);
    
    const iconsDualSelect = {
		moveLeft: <i className="ri-arrow-left-s-line" />,
		moveAllLeft: [
			<i key={0} className="ri-arrow-left-s-line" />,
			<i key={1} className="ri-arrow-left-s-line" />
		],
		moveRight: <i className="ri-arrow-right-s-line" />,
		moveAllRight: [
			<i key={0} className="ri-arrow-right-s-line" />,
			<i key={1} className="ri-arrow-right-s-line" />
		],
		moveDown: <i className="ri-arrow-down-s-line" />,
		moveUp: <i className="ri-arrow-up-s-line" />,
		moveTop: <i className="ri-arrow-up-s-line" />,
		moveBottom: <i className="ri-arrow-down-s-line" />,
	}

    useEffect(() => {
        setOptionsList(itemsList.map(item => {return {value: item.value, label: `${item.name}`}}))
    }, [itemsList])

    return (
        <Row className='g-3 py-2 position-relative'>
            <Col lg={12}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="d-flex align-items-start gap-2 mb-2">
                            <Badge color="blue" radius="md" size="lg">
                                Paso 1
                            </Badge>
                            <div>
                                <h5 className="my-0">Selección de EPP</h5>
                                <p>
                                    Seleccione los elementos de protección personal para el cargo
                                </p>
                            </div>
                        </div>

                        <Card className='border'>
                            <CardBody>
                                <SimpleBar style={{ maxHeight: "300px" }}>
                                    <DualListBox
                                        canFilter={true}
                                        filterPlaceholder='Buscar...'
                                        icons={iconsDualSelect}
                                        options={optionsList}
                                        selected={validation.values.item_ids}
                                        onChange={(newValue) => {
                                            console.log('newValue', newValue)
                                            validation.setFieldValue('item_ids', newValue)
                                        }}
                                        lang={{
                                            availableHeader: "Disponibles",          // Encabezado de la lista de opciones disponibles
                                            selectedHeader: "Seleccionados",        // Encabezado de la lista de opciones seleccionadas
                                            filterPlaceholder: "Filtrar...",        // Placeholder del filtro (requiere canFilter)
                                            moveAll: "Mover todo",                   // Botón para mover todas las opciones
                                            move: "Mover",                           // Botón para mover opciones seleccionadas
                                            moveUp: "Subir",                         // Botón para mover hacia arriba
                                            moveDown: "Bajar",                       // Botón para mover hacia abajo
                                            moveTop: "Ir al inicio",                 // Botón para mover al inicio
                                            moveBottom: "Ir al final",               // Botón para mover al final
                                            notAvailableText: "No hay opciones disponibles", // Mensaje cuando la lista disponible está vacía
                                            notSelectedText: "No hay opciones seleccionadas", // Mensaje cuando la lista seleccionada está vacía
                                            moveToAvailable: "Mover a disponibles",
                                            moveAllToAvailable: "Mover todo a disponibles",
                                            moveToSelected: "Mover a seleccionados",
                                            moveAllToSelected: "Mover todo a seleccionados"
                                        }}
                                    >
                                    </DualListBox>
                                </SimpleBar>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </Col>

        </Row>
    )
}

export default AssignationPPEPosition;
